import api from "../api";
import { API_URL } from "../constants";

export const getDomain = async (id: string) => {
  return api.get(`${API_URL}/v1/domain/${id}`);
};
